import useLayeredContent from './useLayeredContent'
import type { GeneralConsent } from '../../utils/general-consents-config'

export function useContentGeneralConsent() {
    const { queryAll, queryBySlug } = useLayeredContent()

    async function getGeneralConsents() {
        return await queryAll<GeneralConsent>('general-consents')
    }

    async function getGeneralConsentBySlug(slug: string) {
        return await queryBySlug<GeneralConsent>('general-consents', slug)
    }

    return { getGeneralConsents, getGeneralConsentBySlug }
}
